import { type Page, PageType } from '../components/PageConfigProvider/types';

export type FilterPersistenceProps = {
  persistScope?: boolean;
};

export const SHARED_FILTER_SCOPE = 'shared';

const isReportPage = (page: Page) => page.type === PageType.REPORT;

export const getFilterPersistenceProps = (
  page: Page
): FilterPersistenceProps =>
  isReportPage(page) ? { persistScope: false } : {};

export const getFilterScopeKey = (page: Page): string =>
  isReportPage(page) ? `report:${page.id}` : SHARED_FILTER_SCOPE;
